import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type SendFinalCostsToLecInput = {
  confirmPayment: boolean
}

export type CostMissingInvoiceKeys =
  | 'exceptional-expenses'
  | 'activities'
  | 'transfers'
  | 'cultural-outings'
  | 'teaching-hall-costs'
  | 'tefl-costs'

export type CostMissingInvoices = {
  key: CostMissingInvoiceKeys
  label: string
}

export const sendFinalCostsToLec = (centerId: number, data: SendFinalCostsToLecInput) => {
  return restApiClient
    .url(constructApiUrl(API.centers.sendFinalCostsToLec.url, { id: centerId }))
    .post<never, SendFinalCostsToLecInput>(data)
}

export const getCenterCostMissingDocuments = (centerId: number) => {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterCostMissingDocuments.url, { id: centerId }))
    .get<CostMissingInvoices[]>()
}
